export interface NavItem {
    label: string
    href: string
}

export const navigation: NavItem[] = [
    { label: 'Quem Somos', href: '#quem-somos' },
    { label: 'Soluções', href: '#solucoes' },
    { label: 'Metodologia', href: '#metodologia' },
    { label: 'Líderes', href: '#lideres' },
    { label: 'Contato', href: '#contato' },
]
